import React from "react";
import { Lock } from "lucide-react";

/** Visas när användaren får läsa men inte ändra byggherrens dokument. */
export const ReadOnlyNotice: React.FC<{ text?: string }> = ({ text }) => (
  <div className="flex items-center gap-2 rounded-lg border border-dashed border-border bg-muted/40 px-3 py-2 text-sm text-muted-foreground">
    <Lock className="h-4 w-4" />
    {text ??
      "Skrivskyddat läge – du kan läsa och exportera dokumentet, men bara byggherren eller projektägaren kan ändra innehållet."}
  </div>
);

export default ReadOnlyNotice;
